document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', (e) => {
        const quickviewBtn = e.target.closest('.m-product-quickview-button');
        if (!quickviewBtn) return;

        let dispatched = false;

        const checkAndDispatch = (modal) => {
            const form = modal.querySelector(
                '[bss-b2b-quickview-product-form], .m-product-quickview, product-form'
            );
            const productId = form?.querySelector('[bss-b2b-product-id]') || form?.querySelector('[data-product-id]');

            if (form && productId && !dispatched) {
                dispatched = true;
                observer.disconnect();
                document.dispatchEvent(
                    new Event('bss_b2b:QuickviewLoaded', { bubbles: true })
                );
            }
        };

        const observer = new MutationObserver(() => {
            const modal = document.querySelector('.m-modal.m-open-modal, .m-modal[open]');
            if (modal) {
                checkAndDispatch(modal);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'open']
        });

        setTimeout(() => {
            observer.disconnect();
        }, 5000);
    });
});
